import { USER_SERVICE } from "@/services/users.service.js";
import router from '@/router/index';

const user = JSON.parse(localStorage.getItem('user'));
const state = user
    ? { status: { loggedIn: true }, user, processTask: undefined, refresh: undefined }
    : { status: {}, user: null, processTask: undefined, refresh: undefined };

const actions = {
    login({ dispatch, commit }, { username, password }) {
        dispatch('alert/clear', null, { root: true });
        commit('loginRequest', { username });

        USER_SERVICE.login(username, password)
            .then(
                user => {
                    commit('loginSuccess', user);
                    router.push('/');
                },
                error => {
                    commit('loginFailure', user);                
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    updatePassword({ dispatch, commit }, password) {
        dispatch('alert/clear', null, { root: true });
        commit('updatePasswordRequest');
        
        USER_SERVICE.updatePassword(password)
            .then(
                output => {
                    commit('updatePasswordSuccess', output);
                },
                error => {
                    commit('updatePasswordFailure', user);                
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    requestLinkPassword({ dispatch, commit }, username) {
        dispatch('alert/clear', null, { root: true });
        commit('linkRequest');

        USER_SERVICE.requestLink(username)
            .then(
                output => {
                    commit('linkSuccess');
                },
                error => {
                    commit('linkFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    resetPassword({ dispatch, commit }, {username, password, token}) {
        dispatch('alert/clear', null, { root: true });
        commit('resetPasswordRequest');

        USER_SERVICE.resetPassword(username, password, token)
            .then(
                output => {
                    commit('resetPasswordSuccess');
                },
                error => {
                    commit('resetPasswordFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    refreshToken({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('refreshRequest');
        
        /* Refresh the token and try again */
        USER_SERVICE.refreshToken(state.user.refreshToken, state.user.username)
        .then(user =>{
            commit('refreshSuccess', user);
       })
       .catch((error) => 
       {
            commit('refreshFailure', error);
            dispatch('alert/error', error, { root: true });
            dispatch('users/logout', null, { root: true });
       });
    },

    logout({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('logout');

        USER_SERVICE.logout();
    }
};

const mutations = {
    /* Login */
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggedIn: true };
        state.user = user;

        // uncomment if you want to test the token with a set expiration date
        // var currentDate = new Date();
        // user.expiration = new Date(currentDate.getTime() + 3*60000);

        // login successful if there's a jwt token in the response
        if (user && user.refreshToken) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(user));
        }
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    /* Update password */
    updatePasswordRequest(state) {
        state.processTask = null;
    },
    updatePasswordSuccess(state) {
        state.processTask = true;
    },
    updatePasswordFailure(state) {
        state.processTask = false;
    },
    /* Request link */
    linkRequest(state) {
        state.processTask = undefined;
    },
    linkSuccess(state) {
        state.processTask = true;
    },
    linkFailure(state) {
        state.processTask = false;
    },
    /* Reset password */
    resetPasswordRequest(state) {
        state.processTask = null;
    },
    resetPasswordSuccess(state) {
        state.processTask = true;
    },
    resetPasswordFailure(state) {
        state.processTask = false;
    },
     /* refreshToken */
    refreshRequest(state) {
        state.refresh = 'refreshing';
    },
    refreshSuccess(state, user) {
        state.user = user;

        // login successful if there's a jwt token in the response
        if (user && user.refreshToken) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(user));
        }

        state.refresh = true;
    },
    refreshFailure(state) {
        state.refresh = false;
    },
    /* */
    logout(state) {
        state.status = {};
        state.user = null;

        localStorage.removeItem('user');
        localStorage.removeItem('locale');

        router.go('/login'); // Force all modules to reset state
    }
};

export const users = {
    namespaced: true,
    state,
    actions,
    mutations
};